<ng-container *ngIf="items$ | async as items">
  <ng-container *ngIf="!items.data._isLoading; else loader">
    <div *ngIf="type === 'l'; else mediaTemplate" class="card-deck d-flex justify-content-between flex-wrap">
      <ng-container *ngFor="let post of items.data.posts.response.items | slice: 0:displayedArticlesCount">
        <div class="card border-0">
          <div
            class="image-cover image-cover-{{ type }}"
            [style.backgroundImage]="'url(' + post.featured_img + ')'"
          ></div>
          <div class="card-body card-body-l justify-content-start">
            <p class="card-text h5" [innerHTML]="post.publish_time | reefDate: 'longDate'"></p>
            <a
              [routerLink]="['/news', post.url_key]"
              [innerHTML]="
                post.title
                  | truncateHtml
                    : displayedArticleTitleLength
                    : {
                        stripTags: true,
                        reserveLastWord: true
                      }
              "
            >
            </a>
          </div>
        </div>
      </ng-container>
    </div>

    <ng-template #mediaTemplate>
      <ng-container *ngFor="let post of items.data.posts.response.items | slice: 0:displayedArticlesCount">
        <div class="d-flex homepage-news-item">
          <div
            class="me-3 image-cover image-cover-{{ type }}"
            [style.backgroundImage]="'url(' + post.featured_img + ')'"
          ></div>
          <div class="media-body me-3">
            <h6 class="mb-1" [innerHTML]="post.publish_time | reefDate: 'longDate'"></h6>
            <a
              [routerLink]="['/news', post.url_key]"
              [innerHTML]="
                post.title
                  | truncateHtml
                    : displayedArticleTitleLength
                    : {
                        stripTags: true,
                        reserveLastWord: true
                      }
              "
            >
            </a>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="!items.data.posts.response.items.length">
      <div class="container-fluid mb-3 text-center" data-category="figures">
        <div>
          <figure class="figure">
            <ng-container *ngIf="type === 's'; else middleKaliuk">
              <svg class="kaliuk kaliuk-small">
                <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
              </svg>
            </ng-container>
            <ng-template #middleKaliuk>
              <svg class="kaliuk kaliuk-middle">
                <use href="/assets/images/svg_ico/icons.svg#kaliuk"></use>
              </svg>
            </ng-template>
            <figcaption class="figure-caption">
              <h4 i18n="@@news-tile.newsNoCategoryNewsAvailable">There is no news</h4>
            </figcaption>
          </figure>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loader>
  <spinner></spinner>
</ng-template>
